import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import ModalUI from 'components/common/ModalUI';
import { InputField, SelectField } from 'components/form-control';
import { NotifyService } from 'config';
import yup from 'config/yup.custom';
import { SYS_MESS } from 'constants/systemMessage';
import { OPTION_ITEM } from 'models';
import { REPORT_BODY_REQUEST, REPORT_REASON_TYPE } from 'models/report';
import { FormEvent, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { sitterApi } from 'services/sitter';
import { setGlobalLoading } from 'store/reducers/global';
import { FormContainer } from './styles';

interface PopupReportSitterProps {
  open: boolean;
  onClose: () => void;
  target_id: string;
}

interface IForm {
  target_id: string;
  target_role: string;
  reason: OPTION_ITEM;
  description: string;
}

const schema = yup
  .object()
  .shape({
    reason: yup.mixed().required(SYS_MESS.ERROR.REASON_REQUIRED),
    description: yup.string().optional(),
  })
  .required();

export function PopupReportSitter({
  open,
  onClose,
  target_id,
}: PopupReportSitterProps) {
  const [dataReason, setDataReason] = useState<REPORT_REASON_TYPE[]>([]);
  const form = useForm<IForm>({
    resolver: yupResolver(schema),
    defaultValues: {
      target_id: target_id,
      target_role: 'sitter',
      reason: null,
      description: '',
    },
  });

  const { handleSubmit, control, reset } = form;

  const onSubmit = (data: IForm) => {
    const _data: REPORT_BODY_REQUEST = {
      target_id: data.target_id,
      target_role: data.target_role,
      reason_id: data.reason.id.toString(),
      description: data.description,
    };

    setGlobalLoading(true);
    sitterApi
      .report(_data)
      .then(() => {
        onCloseAndResetData();
        NotifyService.success('Report success');
      })
      .catch((e) => {
        NotifyService.error(e);
      })
      .finally(() => setGlobalLoading(false));
  };

  const onCloseAndResetData = () => {
    onClose();
    reset();
  };

  useEffect(() => {
    setGlobalLoading(true);
    sitterApi
      .getReason()
      .then(({ data }) => {
        setDataReason(data.data.rows);
      })
      .catch((e) => {
        NotifyService.error(e);
      })
      .finally(() => setGlobalLoading(false));
  }, []);

  return (
    <ModalUI
      open={open}
      title="Report Sitter"
      onClose={onCloseAndResetData}
      PaperProps={{
        sx: { width: 400, height: 'unset', margin: 3, borderRadius: 2 },
      }}
    >
      <FormContainer
        onSubmit={(event: FormEvent<HTMLFormElement>) => {
          event.stopPropagation();
          handleSubmit(onSubmit)(event);
        }}
      >
        <SelectField
          name="reason"
          control={control}
          placeholder="Reason"
          options={dataReason}
          bindLabel="reason"
        />
        <InputField
          name="description"
          control={control}
          placeholder="Comment"
          multiline
          rows={5}
        />
        <Button type="submit" variant="contained" fullWidth>
          Submit
        </Button>
      </FormContainer>
    </ModalUI>
  );
}

export default PopupReportSitter;
